<script>
import axios from "axios";
import { toast } from "vue3-toastify";
export default {
    computed: {},
    methods: {
        async checkSessionInBackendAsync() {
            try {
                 
                const response =  await axios
                    .get(`/api/auth/checkSession`);
                this.$store.setComponentLoading(true)
                if (response?.data?.responseCode < -1) {
                    this.showError(response?.data?.responseMessage);
                    return true;
                }
                const isSessionOk = response?.data && response.data.responseCode === 0
                if(!isSessionOk) {
                    if(response?.data?.responseCode === -1) {
                        this.closeBistroSessionAndRedirectToLogin();    
                    }
                }
                return response?.data && response.data.responseCode === 0
            } catch (err) {
                this.showErrors(err.response);
                this.closeBistroSessionAndRedirectToLogin();
                return false;
            }

        },
        closeBistroSessionAndRedirectToLogin() {
            toast.error('La sesión ha caducado, serás redirigido al login')
            setTimeout(() => {
                window.location.href = '/login'
                localStorage.setItem("loggedUser", null);
            }, 3000)
        }
    },
};
</script>
